<template>
  <div
    @click="$emit('input', optionValue)"
    :class="
      isSelected
        ? 'text-white bg-gray-900'
        : 'text-gray-700 hover:text-white bg-gray-200 hover:bg-gray-700 hover:text-gray-100'
    "
    class="inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md focus:outline-none focus:shadow-outline-gray focus:border-gray-800 transition duration-150 ease-in-out shadow-sm rounded-md mr-2 mb-2 cursor-pointer"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    optionValue: {},
    value: {},
  },
  computed: {
    isSelected() {
      return this.optionValue === this.value;
    },
  },
};
</script>
